export default __webpack_public_path__ + "static/media/create-trustline-step-1@2x.a38a93fc.png";